import { IConfig } from '../types';
import data from '../data/content.json'

const getIsUPC = () => {
  return process.env.REACT_APP_ENV === 'upc';
};

const getLang = () => document.documentElement.getAttribute('lang');

const getOCAPIHost = () => {
  if (process.env.NODE_ENV === 'development') {
    return 'store.ubi.com';
  }

  return window.location.host;
};

const getProdImageDirectory = () => {
  const libraryId = getIsUPC()
    ? 'shared-library-allsites'
    : 'shared-library-web';
  const assetPath = `https://${window.location.host}/on/demandware.static/-/Library-Sites-${libraryId}/default/${process.env.REACT_APP_HTML_PATH}/`;
  return assetPath;
};


const getCountryCode = () => {
  const localeId =  document.getElementById('root').getAttribute('data-locale');
  return data.filter(
    (locale) => locale.lang === localeId
  )[0].linkCode;
}
let CONFIG: IConfig = {
  clientId: process.env.REACT_APP_OCAPI_CLIENTID,
  isUPC: getIsUPC(),
  countryCode: getCountryCode(),
  lang: getLang(),
  apiHost: getOCAPIHost(),
  assetDirectory: getProdImageDirectory(),
  isPrerendered: (window as any).__PRERENDER_INJECTED !== undefined
};
export default CONFIG;
